// 导入基本公共资源
import http from './../../../base/api/public'
// nodejs的 querystring 模块提供用于解析和格式化 URL 查询字符串的实用工具
// get请求时需要使用的到
// import querystring from 'querystring'
let sysConfig = require('@/../config/sysConfig')
// 定义访问网关的api,分为开发，测试，以及生产环境
let apiPre = sysConfig.apiPre
let service = require('@/../config/serviceList')

// 站点列表
export const getStations = (params) => {
  return http.requestPost(`${apiPre}` + service.res + '/res/station/stationsForSelectByOperatorId', params)
}

export const getGunsInfo = (params) => {
  return http.requestPost(`${apiPre}` + service.res + '/res/gun/getRealtimeGunsInfo', params)
}



// WEBPACK FOOTER //
// ./src/module/operatingCenter/api/chargingMonitor.js